'use client'

import * as React from 'react'
import { LandingHero } from './landing-hero'
import { useI18n } from '@/lib/i18n'

// The signed-in home. Renders the SAME illustrated hero + search as the
// signed-out welcome gate (user-directed 2026-07-08: logging in must not
// change the layout — the old centered logo/title/FilterTags view is gone).
// Only the below-the-fold content differs: no guest CTAs / teaser wall /
// feature story here, just the terms acknowledgment.
export function SearchHome() {
  const { t } = useI18n()

  return (
    <div className="relative bg-gate-bg">
      {/* fill: hero takes the whole viewport below the header with the
          search block vertically centered (user-directed 2026-07-09 — the
          bottom-anchored variant left a large void on tall screens). Terms
          ride inside the hero as a bottom overlay so the view is exactly
          one screen. */}
      <LandingHero fill>
        <p className="absolute inset-x-0 bottom-4 px-8 text-center text-xs text-[rgb(var(--h-ink)/0.5)]">
          {t('home.termsIntro', 'By searching, you agree to our')}{' '}
          <a
            href="/terms"
            className="underline transition-colors hover:text-[rgb(var(--h-ink)/0.8)]"
          >
            {t('home.termsLink', 'Terms of Service')}
          </a>
        </p>
      </LandingHero>
    </div>
  )
}
